import {Document} from "app/archivage/common/services/document/document.model";
import {Deposit} from "../deposit/deposit.model";


export interface Box {
  id?: number;
  type?: BoxType;
  box_number?: number;
  deposit?: number;
  deposit_obj?: Deposit;
  revision_year_min?: number;
  revision_year_max?: number;
  linear_size?: number;
  description?: string;
  observation?: string;
  documents_obj?: Document[];
  dt_created: string;
  dt_updated: string;
}

export const boxControls: [string, string][] = [
  ['type', 'typeSelected'],
  ['description', 'description'],
];

/*
class BoxType(models.IntegerChoices):
    SMALL = 10, 'Boite de 10 cm'
    MEDIUM = 15, 'Boite de 15 cm'
*/
export enum BoxType {
  UNDEF = 0,
  SMALL = 10,
  MEDIUM = 15,
}
